import { inject } from '@angular/core';
import { CanDeactivateFn} from '@angular/router';
import { defer, of } from 'rxjs';
import { AlertService } from '../services/alert.service';

export abstract class IFormWithUnsavedChangesValidation {
  public abstract isTouched(): boolean
}

export const UnsavedChangesGuard: CanDeactivateFn<IFormWithUnsavedChangesValidation> = (component) => {
  const alertService = inject(AlertService)
  if (component != null && component.isTouched != null && typeof(component.isTouched) == 'function' && component.isTouched()) {
    return defer(async () => {
      if (await alertService.showConfirm(`Hay cambios sin guardar, si continuas se perderán los cambios no guardados. ¿Seguro que quieres salir?`, '¡Atención!', 'Sí, descartar cambios', 'No, cancelar')) {
        return true
      } else {
        return false
      }
    })
  }
  return of(true)
}